export interface PatAction {
  senderId?: string
}

export function normalizePatAction(action: unknown): PatAction | undefined {
  if (!action || typeof action !== 'object')
    return undefined

  const candidate = action as { type?: unknown, senderId?: unknown }
  if (candidate.type !== 'pat')
    return undefined

  return typeof candidate.senderId === 'string' && candidate.senderId.trim()
    ? { senderId: candidate.senderId.trim() }
    : {}
}

export function mergePatAction(current: PatAction | undefined, next: PatAction): PatAction {
  return current ?? next
}
